/**
 * popupPref — device-local toggle for the error/warning toast pop-ups shown by
 * WebPopupProvider (top-right of the screen).
 *
 * Default OFF (absent value = disabled): the pop-ups are a diagnostic aid, opt-in
 * per device via Settings → Diagnostics. Stored in localStorage, not synced.
 */

const KEY = 'web-popup-enabled';

export function isWebPopupEnabled(): boolean {
  try {
    return localStorage.getItem(KEY) === 'on';
  } catch {
    return false;
  }
}

export function setWebPopupEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(KEY, enabled ? 'on' : 'off');
  } catch {
    /* no-op */
  }
}
